import { Box, Skeleton, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';

const ConversationCardSkeleton: React.FC = () => {
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      gap={1}
      p={1}
      borderRadius={3}
      bgcolor={palette.action.hover}
    >
      <Skeleton kind="circular" width={40} height={40} />

      <Box flex={1} my={-0.5}>
        <Skeleton kind="text" width="45%" height={30} />

        <Skeleton kind="text" width="30%" height={24} />

        <Skeleton kind="text" width="100%" height={32} />
      </Box>

      <Skeleton kind="circular" width={10} height={10} sx={{ mt: 1 }} />
    </Box>
  );
};

export default ConversationCardSkeleton;
